import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateConfigService } from 'app/services/translate-config.service';

export interface DialogData {
  active: boolean;
  passwordPopUp: boolean 
}

@Component({
    selector: 'app-disable-confirmation-modal',
    templateUrl: './disable-confirmation-modal.component.html',
    styleUrls: ['./disable-confirmation-modal.component.scss'],
    standalone: false
})
export class DisableConfirmationModalComponent implements OnInit {

  constructor(
    private dialog: MatDialogRef<boolean>,
    private translateConfigService: TranslateConfigService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
  }

  close = (close: boolean): any => this.dialog.close(close);
}
